/** Send an email with an authentication code to the user */
export const sessionEmailAuthSpec = {
    uri: '/t/[tenant]/session/email-auth',
    method: 'POST',
    allowAnonymous: true,
};
